var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-container"},[_c('input',{attrs:{"type":"checkbox","id":_vm.checkboxId},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('label',{staticClass:"h5",attrs:{"for":_vm.checkboxId}},[_c('span',{staticClass:"checkbox"}),_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }